import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import { HomeLayout } from "../../HomeLayout";
import logo from "../../logo.png";
import { Col } from "react-bootstrap";
import get_ios from "../../get_ios.png";
import get_android from "../../get_android.png";

export default function HomePage() {
    return (
        <HomeLayout>
            <Row className="text-center">
                <Col className="mb-5">
                    <img src={logo} alt="Meeshosoft" style={{ width: "165px" }} className="avatar" />
                </Col>
                <Row className="mb-5">
                    <Col>
                        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.meeshosoft.phantomletters">
                            <img src={get_android} alt="Get App" style={{ width: "200px" }} />
                        </a>
                        <a target="_blank" href="https://apps.apple.com/app/%D8%AD%D8%B1%D9%88%D9%81-%D9%85%D8%AE%D9%81%D9%8A%D8%A9/id6737517156">
                            <img src={get_ios} alt="Get App" style={{ width: "200px" }} />
                        </a>
                    </Col>
                </Row>
                <p> لأية استفسارات أو للدعم الفني يرجى مراسلتنا على  <a href="mailto: support@meeshosoft.com">support@meeshosoft.com</a></p>
                <p>For inquiries or support requests, Please contact <a href="mailto: support@meeshosoft.com">support@meeshosoft.com</a></p>
            </Row >
        </HomeLayout >
    )
}